import { ColumnDef, Row } from "@tanstack/react-table";
import { useCallback, useContext, useMemo } from "react";
// import AddedColumn from "../components/atoms/tables/dashboards/header/AddedColumn";
import ConnectedAppsColumn from "../components/atoms/tables/dashboards/header/ConnectedAppsColumn";
import CommentaryColumn from "../components/atoms/tables/dashboards/header/CommentaryColumn";
import EmailsColumn from "../components/atoms/tables/dashboards/header/EmailsColumn";
import CustomFieldColumn from "../components/atoms/tables/dashboards/header/CustomFieldColumn";
import DocumentsColumn from "../components/atoms/tables/dashboards/header/DocumentsColumn";
import DescriptionColumn from "../components/atoms/tables/dashboards/header/DescriptionColumn";
import KeyPeopleColumn from "../components/atoms/tables/dashboards/header/KeyPeopleColumn";
// import LinkedInPostsColumn from "../components/atoms/tables/dashboards/header/LinkedInPostsColumn";
import LocationColumn from "../components/atoms/tables/dashboards/header/LocationColumn";
import NameColumn from "../components/atoms/tables/dashboards/header/NameColumn";
import OwnerColumn from "../components/atoms/tables/dashboards/header/OwnerColumn";
import RecentColumn from "../components/atoms/tables/dashboards/header/RecentColumn";
import SelectionColumn from "../components/atoms/tables/dashboards/header/SelectionColumn";
import SourceColumn from "../components/atoms/tables/dashboards/header/SourceColumn";
import AssetClassColumn from "../components/atoms/tables/dashboards/header/AssetClassColumn";
import CompanyQueryColumn from "../components/atoms/tables/dashboards/header/CompanyQueryColumn";
import StageColumn from "../components/atoms/tables/dashboards/header/StageColumn";
import StatusColumn from "../components/atoms/tables/dashboards/header/StatusColumn";
import SyncStatusColumn from "../components/atoms/tables/dashboards/header/SyncStatusColumn";
import TagsGroupColumn from "../components/atoms/tables/dashboards/header/TagsGroupColumn";
// import UpdatedColumn from "../components/atoms/tables/dashboards/header/UpdatedColumn";
// import AddedCell from "../components/atoms/tables/dashboards/rows/AddedCell";
import ConnectedAppsCell from "../components/atoms/tables/dashboards/rows/ConnectedAppsCell";
import CommentaryCell from "../components/atoms/tables/dashboards/rows/CommentaryCell";
import EmailsCell from "../components/atoms/tables/dashboards/rows/EmailsCell";
import CustomFieldCell from "../components/atoms/tables/dashboards/rows/CustomFieldCell";
import DocumentsCell from "../components/atoms/tables/dashboards/rows/DocumentsCell";
import DescriptionCell from "../components/atoms/tables/dashboards/rows/DescriptionCell";
import KeyPeopleCell from "../components/atoms/tables/dashboards/rows/KeyPeopleCell";
// import LinkedInPostsCell from "../components/atoms/tables/dashboards/rows/LinkedInPostsCell";
import LocationCell from "../components/atoms/tables/dashboards/rows/LocationCell";
import NameCell from "../components/atoms/tables/dashboards/rows/NameCell";
import OwnerCell from "../components/atoms/tables/dashboards/rows/OwnerCell";
import RecentCell from "../components/atoms/tables/dashboards/rows/RecentCell";
import SelectionCell from "../components/atoms/tables/dashboards/rows/SelectionCell";
import SourceCell from "../components/atoms/tables/dashboards/rows/SourceCell";
import AssetClassCell from "../components/atoms/tables/dashboards/rows/AssetClassCell";
import CompanyQueryCell from "../components/atoms/tables/dashboards/rows/CompanyQueryCell";
import StageCell from "../components/atoms/tables/dashboards/rows/StageCell";
import StatusCell from "../components/atoms/tables/dashboards/rows/StatusCell";
import SyncStatusCell from "../components/atoms/tables/dashboards/rows/SyncStatusCell";
import TagsGroupCell from "../components/atoms/tables/dashboards/rows/TagsGroupCell";
// import UpdatedCell from "../components/atoms/tables/dashboards/rows/UpdatedCell";
import { GroupSettingsContext } from "../contexts/GroupSettingsContext";
import { Dashboard } from "../types/files";
import { collectionKey } from "../components/organisms/dashboards/DashboardsView";

const useCompaniesTableColumns = () => {
  const { tagGroups, customFields } = useContext(GroupSettingsContext);

  const lookUpTagsSelection = useCallback((dashboard: Dashboard, title: string) =>
    dashboard.tagGroups?.find((dashboard) => dashboard.title.toLowerCase() === title.toLowerCase())?.tags || []
    , []);

  const baseColumns: ColumnDef<Dashboard, any>[] = useMemo(() => [
    {
      id: 'Selection',
      header: () => <SelectionColumn />,
      cell: ({ row }) => <SelectionCell dashboard={row.original} collectionKey={collectionKey} />,
      size: 64,
    }, {
      id: 'Name',
      header: () => <NameColumn />,
      cell: ({ row }) => <NameCell dashboard={row.original} />,
      size: 200,
    }, {
      id: 'Recent Activity',
      header: () => <RecentColumn />,
      cell: ({ row }) => <RecentCell dashboard={row.original} />,
      size: 250,
    }, {
      id: 'Primary Entity',
      header: () => <CompanyQueryColumn />,
      cell: ({ row }) => <CompanyQueryCell dashboard={row.original} />,
      size: 250,
    }, {
      id: 'Asset Class',
      header: () => <AssetClassColumn />,
      cell: ({ row }) => <AssetClassCell dashboard={row.original} />,
      size: 200,
    }, {
      id: 'Status',
      header: () => <StatusColumn />,
      cell: ({ row }) => <StatusCell dashboard={row.original} />,
      size: 200,
    }, {
      id: 'Stage',
      header: () => <StageColumn />,
      cell: ({ row }) => <StageCell dashboard={row.original} />,
      size: 200,
    }, {
      id: 'Key People',
      header: () => <KeyPeopleColumn />,
      cell: ({ row }) => <KeyPeopleCell dashboard={row.original} />,
      size: 250,
    }, {
      id: 'Deck/Teaser',
      header: () => <DocumentsColumn />,
      cell: ({ row }) => <DocumentsCell dashboard={row.original} />,
      size: 250,
    }, {
      id: 'Location',
      header: () => <LocationColumn />,
      cell: ({ row }) => <LocationCell dashboard={row.original} />,
      size: 250,
    }, {
      id: 'Owner',
      header: () => <OwnerColumn />,
      cell: ({ row }) => <OwnerCell dashboard={row.original} />,
      size: 250,
    }, {
      id: 'Source',
      header: () => <SourceColumn />,
      cell: ({ row }) => <SourceCell dashboard={row.original} />,
      size: 250,
    },
    {
      id: 'Connected Apps',
      header: () => <ConnectedAppsColumn />,
      cell: ({ row }) => <ConnectedAppsCell dashboard={row.original} />,
      size: 200,
    },
    // {
    //   id: 'LinkedIn Posts',
    //   header: () => <LinkedInPostsColumn />,
    //   cell: ({ row }) => <LinkedInPostsCell dashboard={row.original} />,
    //   size: 250,
    // },
    {
      id: 'Emails',
      header: () => <EmailsColumn />,
      cell: ({ row }) => <EmailsCell dashboard={row.original} />,
      size: 300,
    }, {
      id: 'Commentary',
      header: () => <CommentaryColumn />,
      cell: ({ row }) => <CommentaryCell dashboard={row.original} />,
      size: 250,
    }, {
      id: 'Description',
      header: () => <DescriptionColumn />,
      cell: ({ row }) => <DescriptionCell dashboard={row.original} />,
      size: 250,
    }, {
      id: 'Sync Status',
      header: () => <SyncStatusColumn />,
      cell: ({ row }) => <SyncStatusCell dashboard={row.original} />,
      size: 250,
    },
    // {
    //   id: 'Updated',
    //   header: () => <UpdatedColumn />,
    //   cell: ({ row }) => <UpdatedCell dashboard={row.original} />,
    //   size: 150,
    // }, {
    //   id: 'Added',
    //   header: () => <AddedColumn />,
    //   cell: ({ row }) => <AddedCell dashboard={row.original} />,
    //   size: 150,
    // }
  ], []);

  const tagGroupsColumns: ColumnDef<Dashboard, any>[] = useMemo(() =>
    tagGroups.map(({ title, tags, tagsPerDashboard }, i) => ({
      id: title || `Unnamed Tag Group [${i + 1}]`,
      header: () => (
        <TagsGroupColumn
          tagGroup={title}
          key={`use-companies-table-columns-148-${title || i}`}
        />
      ),
      cell: ({ row }: { row: Row<Dashboard> }) => (
        <TagsGroupCell
          dashboard={row.original}
          tagGroup={title}
          tagsPerDashboard={tagsPerDashboard}
          tags={tags}
          selections={lookUpTagsSelection(row.original, title)}
          key={`use-companies-table-columns-158-${title || i}`}
        />
      ),
      size: 300,
    })), [tagGroups, lookUpTagsSelection]);

  const customFieldColumns: ColumnDef<Dashboard, any>[] = useMemo(() =>
    customFields.map(({ name }, i) => ({
      id: name || `Unnamed Field [${i + 1}]`,
      header: () => (
        <CustomFieldColumn
          fieldName={name}
          key={`use-companies-table-columns-170-${name || i}`}
        />
      ),
      cell: ({ row }: { row: Row<Dashboard> }) => (
        <CustomFieldCell
          dashboard={row.original}
          fieldName={name}
          key={`use-companies-table-columns-177-${name || i}`}
        />
      ),
      size: 250,
    })), [customFields]);

  const defaultColumns: ColumnDef<Dashboard, any>[] = useMemo(() => [
    ...baseColumns.slice(0, 5),
    ...tagGroupsColumns,
    ...customFieldColumns,
    ...baseColumns.slice(5),
  ], [baseColumns, tagGroupsColumns, customFieldColumns]);

  return { defaultColumns };
};

export default useCompaniesTableColumns;
